import { useState } from 'react'

import { FormProvider, useForm } from 'react-hook-form'
import toastr from 'toastr'

import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { api } from '@/shared/lib/api'
import { Button } from '@/shared/ui'
import { BottomSheetWrapper } from '@/shared/ui/BottomSheetWrapper'

import { DigitalProductCheckoutAditionalInformationFields } from '.'
import {
  getAddInfoAnswerRecord,
  getAddInfoAnswerValue,
  getAddInfosByPriceId,
  mergeTicketAdditionalInformations
} from './utils'

export const EditAdditionalInformation = ({
  id,
  price_id: priceId,
  additional_informations: addInfoAnswers = [],
  onSave,
  openEditInfo,
  setOpenEditInfo
}) => {
  const { digitalProduct } = useDigitalProductContext()
  const addInfos = getAddInfosByPriceId({ digitalProduct, priceId })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const methods = useForm()

  toastr.options = {
    positionClass: 'toast-top-right'
  }

  const handleSaveEditAddInfo = async (data: any) => {
    if (isSubmitting) return

    setIsSubmitting(true)

    await api.put(`/user/tickets/${id}`, {
      record: {
        additional_informations: mergeTicketAdditionalInformations(
          addInfoAnswers,
          data?.additional_informations
        )
      }
    })
    toastr.success('Informações salvas com sucesso', 'Feito!')

    onSave()
    setIsSubmitting(false)
  }

  return (
    <BottomSheetWrapper
      open={openEditInfo}
      onClose={() => setOpenEditInfo(false)}
      title="Editar Informações Adicionais"
      className="custom-bottom-sheet"
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(handleSaveEditAddInfo)}
          className="w-full"
        >
          {addInfos &&
            addInfos.map((addInfo: any, addInfoIndex: number) => {
              const addInfoAnswer = getAddInfoAnswerRecord(
                addInfoAnswers,
                addInfo.id,
                addInfo.name
              )
              const answer = getAddInfoAnswerValue(addInfoAnswer, addInfo)

              return (
                <DigitalProductCheckoutAditionalInformationFields
                  key={addInfo?.id}
                  namePrefix={`additional_informations.${addInfoIndex}`}
                  answer={answer}
                  {...addInfo}
                />
              )
            })}
          <div className="flex items-center justify-end gap-4">
            <Button
              type="button"
              variant="light"
              onClick={() => setOpenEditInfo(false)}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="success"
              disabled={isSubmitting}
              loading={isSubmitting}
              showTrailingIcon={false}
            >
              {isSubmitting ? 'Salvando...' : 'Salvar'}
            </Button>
          </div>
        </form>
      </FormProvider>
    </BottomSheetWrapper>
  )
}
